module.exports = function (chart) {
  var scaleController = chart.get('scaleController') || {};
  return scaleController.defs;
};


//////////////////
// WEBPACK FOOTER
// ./src/interaction/helper/get-col-defs.js
// module id = 377
// module chunks = 0